import axios, { type AxiosError } from 'axios';
import { useMutation } from 'react-query';

import { type TBaseRequestPayload } from '@/types/request';
import { type TBaseResponse, type TErrorResponse } from '@/types/response';

type TAcceptTermsResponse = TBaseResponse & {
  terms_acceptance?: {
    transport_tracking_number: string;
    transport_uuid: string;
    uuid: string;
  };
};

type TAcceptTermsRequestPayload = TBaseRequestPayload & {
  transportId: string;
};

const acceptTerms = async ({
  transportId,
}: TAcceptTermsRequestPayload): Promise<TAcceptTermsResponse> => {
  const response = await axios.post<TAcceptTermsResponse>(
    `/api/v1/transports/${transportId}/accept-terms`
  );

  return response.data;
};

const useAcceptTermsMutation = () => {
  return useMutation<
    TAcceptTermsResponse,
    AxiosError<TErrorResponse>,
    TAcceptTermsRequestPayload
  >((payload) => acceptTerms(payload));
};

export { useAcceptTermsMutation, acceptTerms };
